import { render, staticRenderFns } from "./NotificationsTable.vue?vue&type=template&id=03dc4a0c"
import script from "./NotificationsTable.vue?vue&type=script&lang=js"
export * from "./NotificationsTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationsTable.vue?vue&type=style&index=0&id=03dc4a0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports